
function update_timer() {
  var custom_timer = document.querySelector(".discount_order .timingdiscount");
  /*var durationInMinutes = 15;
  const durationInMilliseconds = durationInMinutes * 60 * 1000;
  let endTime = Date.now() + durationInMilliseconds;*/
  if(custom_timer){
    var endTime = localStorage.getItem('endTime');
    if(!endTime) return
    const intervalId = setInterval(() => {
        const remainingMilliseconds = endTime - Date.now();
        const remainingMinutes = Math.floor(remainingMilliseconds / 60000);
        const remainingSeconds = Math.round((remainingMilliseconds % 60000) / 1000);
        const formattedTime = `${remainingMinutes.toString().padStart(2, '0')}m:${remainingSeconds.toString().padStart(2, '0')}s`;
        custom_timer.textContent = formattedTime;
  
        if (remainingMilliseconds <= 0) {
            clearInterval(intervalId);
            //custom_timer.text('Hurrey!!');
            setTimeout(startTimer, 3000); // Restart the timer after 3 seconds
        }
    }, 1000);
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form.querySelector('[name=id]')) 
        this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      var is_product_template = Array.from(document.querySelector("body").classList).filter((elem) => elem.includes("product-")).length;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if(is_product_template){
        if(formData.get("properties\\[_bogo\\]") == "true" && ! formData.get("properties\\[_freegiftid\\]")){ // Bogo product added to cart
           formData.append("properties\\[_freegiftid\\]", formData.get("id"));
        }
      }
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      var quizz_gift_trigger = formData.get("properties\\[_quizz-gift-trigger\\]");

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            //publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart && window.routes.cart_url) {
            /*window.location = window.routes.cart_url;
            return;*/
          }
          if (is_product_template){//product page template
            if(response.properties["_bogo"] ){
              let gift_id = response.properties["_freegiftid"] ? response.properties["_freegiftid"] : response.id,
                gift_quantity = response.properties["_bogo_quantity"] ? response.properties["_bogo_quantity"] : 1;
              if(gift_id){ // add the free product to cart aswell
                var formData = {
                  items: [
                    {
                      id: gift_id,
                      quantity : gift_quantity,
                      properties : {
                        '_freegift': true
                      }
                    }
                  ],
                  sections : this.cart.getSectionsToRender().map((section) => section.id)
                };
                $.ajax({
                  url: "/cart/add.js",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  data: JSON.stringify(formData),
                  success : (data) => {
                    console.log(JSON.parse(data));
                    this.cart.renderContents(JSON.parse(data));
                  }
                });
              }
            }
          }
          //if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          }else if(document.querySelector("body.page-quizz")){
            let gift_id = document.querySelector(".offer-item.free-item").querySelector("input[name='id']").value;
            if(gift_id){ // add the free product to cart
              var formData = {
                items: [
                  {
                    id: gift_id,
                    properties : {
                      '_free_quiz_gift': true
                    }
                  }
                ],
              };
              $.ajax({
                url: "/cart/add.js",
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                data: JSON.stringify(formData),
                success : () => {
                  setTimeout(() => {window.location.href = "/checkout"},1500);
                }
              });
            }
          } else if(document.querySelector("body.page-quiz_v1")/* && quizz_gift_trigger == "true"*/){ // Only Add the gift product once
            let second_offer_id = document.querySelectorAll(".offer-item.active")[1]?.querySelector("input[name='id']")?.value,
              second_offer_quantity = document.querySelectorAll(".offer-item.active")[1]?.querySelector(".quantity__input")?.value,
              second_offer_selling_plan = document.querySelectorAll(".offer-item.active")[1]?.querySelector("input[name='selling_plan']")?.value,
              gift_id = document.querySelector(".offer-item.free-item").querySelector("input[name='id']").value;
            if(gift_id){ // add the free product to cart
            var formData = {
              items: [
                second_offer_id ? { // Conditionally include this object if second_offer_id exists
                  id: second_offer_id,
                  quantity: second_offer_quantity,
                  selling_plan : second_offer_selling_plan,
                  properties: {
                    '_quizzresult': true
                  }
                } : null, // Use null if the condition is false
                { // Free gift is always included
                  id: gift_id,
                  properties: {
                    '_free_quiz_gift': true,
                    '_quizz_threshold' : document.querySelectorAll(".offer-item.active:not(.free-item)").length
                  }
                }
              ].filter(item => item !== null) // Filter out null values
            };
            console.log(formData)
              $.ajax({
                url: "/cart/add.js",
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                data: JSON.stringify(formData),
                success : () => {
                  setTimeout(() => {window.location.href = "/checkout"},1500);
                }
              });
            }
          }else{
            this.cart.renderContents(response);
          }
          if (document.querySelector("body.page-christmas_gifting")){
            let gift_id = this.querySelector('.free-item').dataset.id;
            if(gift_id){ // add the free product to cart aswell
              var formData = {
                items: [
                  {
                    id: gift_id,
                    properties : {
                      '_freegift': true
                    }
                  }
                ],
                sections : this.cart.getSectionsToRender().map((section) => section.id)
              };
              $.ajax({
                url: "/cart/add.js",
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                data: JSON.stringify(formData),
                success : (data) => {
                  console.log(JSON.parse(data));
                  this.cart.renderContents(JSON.parse(data));
                }
              });
            }
          }
          else if (document.querySelector(".product_free_gift") || document.querySelector(".buy-offer-1")){
            let gift_id = this.querySelector('input.free_gift_ids').value,
                gift_array = gift_id.split(","),
                quantity = $(".offer_quantity [name='quantity']:checked").val() || 1;

            if(gift_id){ // add the free product to cart aswell
              var formData = {
                items: gift_array.map( (gift) =>  {
                  return{
                    id: gift,
                    quantity : quantity,
                    properties : {
                      '_freegift': true
                  }
                  }
                }),
                sections : this.cart.getSectionsToRender().map((section) => section.id)
              };
              $.ajax({
                url: "/cart/add.js",
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                data: JSON.stringify(formData),
                success : (data) => {
                  console.log(JSON.parse(data));
                  this.cart.renderContents(JSON.parse(data));
                }
              });
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          update_timer();
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}